import React from "react";
import { ScaleLoader } from "react-spinners";

const Loader = () => (
  <div className="text-center loadingDiv">
    <ScaleLoader color="#fff" />
  </div>
);
export default Loader;
